var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.regionMap)?_c('div',[_c('div',{staticClass:"text-2xl"},[_vm._v("Lead Assignment")]),_c('lead-assignment')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }